// strongly typed Object.entries so we can protect against theme changes that don't also update the CSS generation
export function getEntries(obj) {
  return Object.entries(obj);
}
export const groupReplacements = {
  color: 'color',
  space: 'space',
  borderRadius: 'border-radius',
  borderWidth: 'border-width',
  fontSize: 'font-size',
  fontWeight: 'font-weight',
  boxShadow: 'box-shadow'
};
export const typographyReplacements = {
  fontFamily: 'font-family',
  fontWeight: 'font-weight',
  fontSize: 'font-size',
  lineHeight: 'line-height',
  letterSpacing: 'letter-spacing',
  textUnderlineOffset: 'text-underline-offset'
};

/**
 * Creates a map of Trellis CSS var -> CSS variable value
 */
export function createCssVarsFromTheme(themeObject) {
  const cssVarMap = {};
  for (const [group, values] of getEntries(themeObject)) {
    if (group === 'typography') {
      for (const [varName, typographyValues] of getEntries(values)) {
        for (const [key, value] of getEntries(typographyValues)) {
          if (value == null) {
            continue;
          }
          const replacementKey = typographyReplacements[key] || key;
          cssVarMap[`--trellis-${group}-${varName}-${replacementKey}`] = value;
        }
      }
    } else {
      const groupName = groupReplacements[group] || group;
      for (const [varName, value] of Object.entries(values)) {
        if (value == null) {
          continue;
        }
        if (varName.startsWith('do-not-use')) {
          continue;
        }
        cssVarMap[`--trellis-${groupName}-${varName}`] = value;
      }
    }
  }
  return cssVarMap;
}